import { ProgrammeContent } from "../../components/configuration";

export default function Programme() {
  return (
    <>
      <ProgrammeContent />
    </>
  );
}
